module.exports = __webpack_public_path__ + "img/Porto Apartment - 17 of 85.21d3b149.jpeg";